import { Injectable } from "@angular/core";
import { FileResultList } from "../../../_services/image-upload-offline.service";

@Injectable({
  providedIn: "root"
})
export class UploadProgressDialogService {
  public totalFileCount = 0;
  public completeFileCount = 0;
  public successFileCount = 0;
  public failureFileCount = 0;
  public isDisabledCancel = false;
  public imageFileResultList = new FileResultList();
  public failedFileNameList: string[] = [];
  public isError = false;

  progressMode: "saveFile" | "receiveFile" | "directFileTransfer" = "saveFile";

  public transferStartTime = 0;
  public saveStartTime = 0;
  public totalFileSize = 0;
  public loadedFileSize = 0;
  public isSaveStart = false;

  get fileUploadProgress() {
    return Math.floor((this.completeFileCount / this.totalFileCount) * 100);
  }

  constructor() {
    this.init();
  }

  init() {
    this.totalFileCount = 0;
    this.completeFileCount = 0;
    this.successFileCount = 0;
    this.failureFileCount = 0;
    this.isDisabledCancel = false;
    this.isError = false;
    this.failedFileNameList = [];
    this.imageFileResultList = new FileResultList();
    this.progressMode = "saveFile";
    this.transferStartTime = 0;
    this.saveStartTime = 0;
    this.totalFileSize = 0;
    this.loadedFileSize = 0;
    this.isSaveStart = false;
  }

  initReceiveMode(totalFileCount: number, totalFileSize: number, startTime: number, progressMode: "saveFile" | "receiveFile" | "directFileTransfer") {
    this.init();
    this.totalFileCount = totalFileCount;
    this.progressMode = progressMode;
    this.transferStartTime = startTime;
    this.totalFileSize = totalFileSize;
  }

  countLoadedFileSize(fileSize: number) {
    this.loadedFileSize += fileSize;

    if (this.progressMode === "receiveFile" && this.loadedFileSize >= this.totalFileSize) {
      this.isSaveStart = true;
    }
  }
}
